import { render } from "./PlaceForm.vue?vue&type=template&id=723a89fd"
import script from "./PlaceForm.vue?vue&type=script&lang=js"
export * from "./PlaceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SetUp/Location/PlaceForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "723a89fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('723a89fd', __exports__)) {
    api.reload('723a89fd', __exports__)
  }
  
  module.hot.accept("./PlaceForm.vue?vue&type=template&id=723a89fd", () => {
    api.rerender('723a89fd', render)
  })

}


export default __exports__